import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useStandaloneCopilotApp } from '@office-start/copilot-route-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { IDLE_VERYLOW_PRIORITY, IMMEDIATE_PRIORITY, } from '@office-start/scheduler-service';
import { getQueryParams, getUrlQueryString, } from '@office-start/url-parser-utility';
import React, { lazy, useMemo } from 'react';
import { LazyFeature } from '../LazyFeature/LazyFeature';
import { withLazyErrorBoundary } from '../LazyFeature/withLazyErrorBoundary';
import { ShellHeaderComponentFallback } from './ShellHeaderComponentFallbackOptions';
var MockHeaderLazy = lazy(function () { return import(/*webpackChunkName: "mockheader" */ './MockHeader'); });
var appbarConnectorService = AppbarConnectorService.getInstance();
export var Header = function () {
    var _a, _b, _c, _d, _e, _f;
    var isStandaloneCopilotApp = useStandaloneCopilotApp();
    var inMockMode = (_b = (_a = useOfficeComponentContext()) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.inMockMode;
    var inMockShell = getQueryParams(getUrlQueryString(), true)['mockshell'] === '1';
    var isCopilotPage = appbarConnectorService.getIsCopilotChatExperience() ||
        isStandaloneCopilotApp;
    var featureGates = (_d = (_c = useFeatureGates()) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.result;
    var shellHeaderLazyLoadEnabled = (_f = (_e = featureGates === null || featureGates === void 0 ? void 0 : featureGates.shellGates) === null || _e === void 0 ? void 0 : _e.shellHeaderLazyLoadEnabled) !== null && _f !== void 0 ? _f : false;
    var ShellHeaderLazy = useMemo(function () {
        return withLazyErrorBoundary(lazy(function () {
            return import(
            /*webpackChunkName: "shellheader" */ './ShellHeader');
        }), 'ShellHeader', {
            schedulePriority: shellHeaderLazyLoadEnabled && isCopilotPage
                ? IDLE_VERYLOW_PRIORITY
                : IMMEDIATE_PRIORITY,
            fallback: ShellHeaderComponentFallback,
        });
    }, []);
    if (inMockMode && !inMockShell) {
        return (React.createElement(LazyFeature, null,
            React.createElement(MockHeaderLazy, null)));
    }
    return React.createElement(ShellHeaderLazy, null);
};
//# sourceMappingURL=Header.js.map